import type en from '../en/monitoring'
import type { Translation } from '../types'

/** Monitoring and alerts */
const monitoring: Translation<typeof en> = {
  "monitoring.subtitle": "Echtzeitstatus aller Standorte",
  "monitoring.online": "Online",
  "monitoring.warning": "Warnung",
  "monitoring.offline": "Offline",
  "monitoring.awaitingVpn": "Wartet auf VPN",
  "monitoring.noData": "Keine Daten",
  "monitoring.lastSeen": "Zuletzt gesehen {when}",
  "monitoring.alertsActive": { one: "{count} aktive Warnung", other: "{count} aktive Warnungen" },
  "monitoring.alertsResolved": { one: "{count} behobene Warnung", other: "{count} behobene Warnungen" },
  "monitoring.active": "Aktiv",
  "monitoring.resolved": "Behoben",
  "monitoring.noResolved": "Keine behobenen Warnungen",
  "monitoring.allClear": "Alles in Ordnung!",
  "monitoring.noneResolvedYet": "Es wurden noch keine Warnungen behoben.",
  "monitoring.healthy": "Keine aktiven Warnungen – Ihr Netzwerk ist in Ordnung.",
  "monitoring.acknowledge": "Bestätigen",
  "monitoring.acknowledged": "✓ Bestätigt",
  "monitoring.resolvedWhen": "✓ Behoben {when}",
  "monitoring.category.VPN": "VPN",
  "monitoring.category.cellular": "Mobilfunk",
  "monitoring.category.device": "Gerät",
  "monitoring.category.firmware": "Firmware",
  "monitoring.category.license": "Lizenz",
  "monitoring.category.link": "Verbindung",
  "monitoring.category.speedfusion": "SpeedFusion",
  "monitoring.category.sync": "Synchronisierung",
  "monitoring.category.wan": "WAN",
  "monitoring.category.wifi": "WLAN",
}

export default monitoring
